import { Link } from "react-router-dom";
import { Container } from "layout";
import { JobState } from "./useJob";

/** Loading, not-found and error screens shared by the job pages. */
export const JobStatus = ({ state }: { state: Exclude<JobState, { status: "ready" }> }) => {
  if (state.status === "loading") {
    return (
      <Container isPage>
        <p role="status" className="text-gray-500">
          Loading…
        </p>
      </Container>
    );
  }
  return (
    <Container isPage>
      <div role="alert" className="rounded-2xl bg-white p-8 text-center">
        <h1 className="text-2xl font-semibold text-gray-900">
          {state.status === "not-found"
            ? "This role is no longer open"
            : "Something went wrong"}
        </h1>
        <p className="mt-2 text-gray-600">
          {state.status === "not-found"
            ? "It may have been filled or closed."
            : "We couldn't load this role. Please try again in a moment."}
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-lg bg-orange-500 px-4 py-2 font-medium text-white hover:bg-orange-600"
        >
          See all open roles
        </Link>
      </div>
    </Container>
  );
};
